import Footer from "../components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background pt-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="mb-8">
          <span className="genre-badge text-primary border-primary mb-4 inline-block">
            LEGAL
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl font-black text-foreground">
            Privacy Policy
          </h1>
          <p className="text-muted-foreground mt-2">Last updated: January 2025</p>
        </div>

        <div className="bg-card border border-border p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              1. Information We Collect
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Name and contact information (email address, phone number)</li>
              <li>Payment information processed securely through Stripe</li>
              <li>Travel preferences and booking history</li>
              <li>Communications you send to us</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              2. How We Use Your Information
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Process and fulfil your bookings</li>
              <li>Send booking confirmations and travel updates</li>
              <li>Respond to your comments and questions</li>
              <li>Improve our services and develop new features</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              3. Information Sharing
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We share your information with third-party service providers who perform services 
              on our behalf, including payment processing (Stripe), travel providers (airlines, hotels), 
              and event organisers. We do not sell your personal information.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              4. Data Security
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We implement appropriate security measures to protect your personal information. 
              All payment information is encrypted and processed through PCI-compliant payment processors.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold text-foreground mb-4">
              5. Contact Us
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at{" "}
              <a 
                href="mailto:hello@xtriptour.com" 
                className="text-primary hover:underline"
              >
                hello@xtriptour.com
              </a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
